<template>
  <div class="flex flex-col h-full">
    <lerner-header :show-login-form="false" :pending="pending"></lerner-header>
    <page-header title="Reset Your Password"></page-header>
    <ResetPasswordForm v-on:submit="submitResetPassword" class="flex-1"/>
    <app-footer :pages="pages" class="w-full pin-b"></app-footer>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';

  import AppFooter from '@/component/AppFooter';
  import LernerHeader from '@/component/Header';
  import ResetPasswordForm from './ResetPasswordForm';
  import AuthService from '@/common/services/auth.service';
  import PageHeader from '@/component/PageHeader';
  import { CHANGE_DOC_TITLE, SHOW_NOTIFICATION } from '@/store/actions/app.actions';
  import { LOGOUT } from '@/store/actions/auth.actions';
  import { getError } from '@/common/services/http.service';

  export default {
    name: 'ResetPassword',

    components: {
      PageHeader,
      ResetPasswordForm,
      LernerHeader,
      AppFooter
    },

    data: () => {
      return {
        pending: false
      }
    },

    created: function () {
      this.$store.dispatch(CHANGE_DOC_TITLE, {title: 'Reset Password', useBaseTitle: true});

      // log out the user
      this.$store.dispatch(LOGOUT);
    },

    computed: {
      ...mapGetters([
        'pages'
      ])
    },

    methods: {
      submitResetPassword(data) {
        this.pending = true;

        AuthService.resetPassword(data)
            .then(() => {
              this.$store.dispatch(SHOW_NOTIFICATION, {type: 'success', message: 'Your password has been updated.'});
              this.$router.push({name: 'home'});
            })
            .catch(e => this.$store.dispatch(SHOW_NOTIFICATION, {type: 'error', message: getError(e)}))
            .finally(() => this.pending = false);
      }
    }
  };
</script>
